<template>
  <div class="advanced-analytics">
    <!-- تب‌های مختلف آنالیز -->
    <SaleAssistant/>
    <CCard no-body>
      <CTabs card>
        <!-- تب تحلیل حساسیت قیمتی -->
        <CTab title="تحلیل حساسیت قیمتی" active>
          <CDataTableFixed
              sorter
              column-filter
              hover
              :items="priceSensitivityData"
              :fields="priceSensitivityFields"
          >
            <template #sensitivity_index="{item}">
              <td>
                <CBadge :color="getSensitivityBadge(item.sensitivity_index)">
                  {{ parseFloat(item.sensitivity_index) }}
                </CBadge>
              </td>
            </template>
            <template #avg_price="{item}">
              <td>
                <p>{{get_currency(item.avg_price)}}</p>
              </td>
            </template>
            <template #avg_discount="{item}">
              <td>
                <p>{{get_currency(item.avg_discount)}}</p>
              </td>
            </template>
            <template #total_sales="{item}">
              <td>
                <p>{{get_currency(item.total_sales)}}</p>
              </td>
            </template>
            <template #total_revenue="{item}">
              <td>
                <p>{{get_currency(item.total_revenue)}}</p>
              </td>
            </template>


            <template #actions="{item}">
              <td>

                <CButton color="primary" size="sm" variant="outline-primary" @click="applyDiscountStrategy(item)">
                  استراتژی تخفیف
                </CButton>
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- تب سگمنت‌بندی مشتریان -->
        <CTab title="سگمنت‌بندی مشتریان">
          <div class="row mb-4">
            <div class="col-md-3" v-for="(summary, segment) in segmentSummary" :key="segment">
              <CCard class="text-center">
                <CCardHeader>
                  {{ getSegmentTitle(segment) }}
                </CCardHeader>
                <CCardBody>
                  <h4>{{ summary.count }}</h4>
                  <p>مشتری</p>
                  <small>میانگین ارزش: {{ summary.avg_order_value.toLocaleString() }} تومان</small>
                </CCardBody>

              </CCard>
            </div>
          </div>

          <CDataTableFixed
              sorter
              column-filter
              hover
              :items="customerSegments"
              :fields="segmentFields" striped>
            <template #segment="{item}">
              <td>
                <CBadge :color="getSegmentBadge(item.segment)">
                  {{ getSegmentTitle(item.segment) }}
                </CBadge>
              </td>
            </template>
            <template #total_spent="{item}">
              <td>
               <p>{{get_currency(item.total_spent)}}</p>
              </td>
            </template>
            <template #actions="{item}">
              <td>
                <CButton color="primary" size="sm" variant="outline-info" @click="viewCustomerDetails(item)">
                  جزئیات
                </CButton>
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- تب ستاره‌ها و مرده ها -->
        <CTab title="تحلیل محصولات (ستاره‌ها و مرده ها)">
          <div class="row mb-4">
            <div class="col-md-3">
              <CCard bg-variant="success" text-variant="white" class="text-center">
                <CCardHeader>
                  ستاره‌ها
                </CCardHeader>
                <h4>{{ starsCount }}</h4>
                <p>محصول پرفروش</p>
              </CCard>
            </div>
            <div class="col-md-3">
              <CCard bg-variant="warning" text-variant="dark" class="text-center">
                <CCardHeader>
                  مرده ها
                </CCardHeader>
                <h4>{{ dogsCount }}</h4>
                <p>محصول کم‌فروش</p>
              </CCard>
            </div>
            <div class="col-md-3">
              <CCard bg-variant="danger" text-variant="white" class="text-center">
                <CCardHeader>
                  محصولات مرده
                </CCardHeader>
                <h4>{{ deadCount }}</h4>
                <p>بدون فروش</p>
              </CCard>
            </div>
          </div>

          <CTabs>
            <CTab title="ستاره‌ها">
              <CDataTableFixed
                  sorter
                          column-filter

                          :items="starsData" :fields="productFields" striped hover>
                <template #category="{item}">
                  <td>
                    <CBadge color="success">{{ item.category }}</CBadge>
                  </td>
                </template>



                <template #total_sold="{item}">
                  <td>
                    <p>{{get_currency(item.total_sold)}}</p>
                  </td>
                </template>
                <template #total_revenue="{item}">
                  <td>
                    <p>{{get_currency(item.total_revenue)}}</p>
                  </td>
                </template>
                <template #avg_price="{item}">
                  <td>
                    <p>{{get_currency(item.avg_price)}}</p>
                  </td>
                </template>
                <template #actions>
                  <td>

                  </td>

                </template>
              </CDataTableFixed>
            </CTab>
            <CTab title="مرده ها">
              <CDataTableFixed sorter
                               column-filter

                               :items="dogsData"
                               :fields="productFields"
                               striped hover>
                <template #category="{item}">
                  <td>
                    <CBadge color="warning">{{ item.category }}</CBadge>
                  </td>
                </template>


                <template #total_sold="{item}">
                  <td>
                    <p>{{get_currency(item.total_sold)}}</p>
                  </td>
                </template>
                <template #total_revenue="{item}">
                  <td>
                    <p>{{get_currency(item.total_revenue)}}</p>
                  </td>
                </template>
                <template #avg_price="{item}">
                  <td>
                    <p>{{get_currency(item.avg_price)}}</p>
                  </td>
                </template>
                <template #actions="{data}">
                  <td>

                    <CButton size="sm" color="outline-danger" @click="applyClearanceStrategy(data)">
                      حراجی فوری
                    </CButton>
                  </td>

                </template>
              </CDataTableFixed>
            </CTab>
          </CTabs>
        </CTab>

        <CTab title="تحلیل RFM مشتریان">
          <CDataTableFixed sorter
                           column-filter
                            :items="rfmData" :fields="rfmFields" striped hover>
            <template #segment="{item}">
              <td>
                <CBadge :color="getRfmBadge(item.segment)">{{ item.segment }}</CBadge>
              </td>
            </template>

            <template #monetary="{item}">
              <td>
                <p>{{get_currency(item.monetary)}}</p>
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- کارایی تخفیف‌ها -->
        <CTab title="کارایی تخفیف‌ها">
          <CDataTableFixed sorter
                           column-filter

                            :items="discountData"
                           :fields="discountFields"
                           striped hover>
            <template #effectiveness_ratio="{item}">
              <td>
                {{item.effectiveness_ratio}}
                <CProgress :value="item.effectiveness_ratio" :max="100" color="primary" show-value></CProgress>
              </td>
            </template>



            <template #avg_discount="{item}">
              <td>
                <p>{{get_currency(item.avg_discount)}}</p>
              </td>
            </template>
            <template #total_sales="{item}">
              <td>
                <p>{{get_currency(item.total_sales)}}</p>
              </td>
            </template>
            <template #total_revenue="{item}">
              <td>
                <p>{{get_currency(item.total_revenue)}}</p>
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- ارزش طول عمر مشتری -->
        <CTab title="ارزش طول عمر مشتری (LTV)">
          <CDataTableFixed sorter
                           column-filter
                            :items="ltvData" :fields="ltvFields" striped hover>

            <template #total_orders="{item}">
              <td>
                <p>{{get_currency(item.total_orders)}}</p>
              </td>
            </template>
            <template #lifetime_value="{item}">
              <td>
                <p>{{get_currency(item.lifetime_value)}}</p>
              </td>
            </template>
            <template #customer_span="{item}">
              <td>
                <p>{{get_currency(item.customer_span)}}</p>
              </td>
            </template>
            <template #ltv_per_month="{item}">
              <td>
                <p>{{get_currency(item.ltv_per_month)}}</p>
              </td>
            </template>




          </CDataTableFixed>
        </CTab>

        <!-- تحلیل سبد خرید -->
        <CTab title="تحلیل سبد خرید">
          <CDataTableFixed sorter
                           column-filter
                           :items="basketData" :fields="basketFields" striped hover>
            <template #support_percentage="{item}">
              <td>
                <CBadge color="info">{{ item.support_percentage }}%</CBadge>

              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- پیش‌بینی موجودی -->
        <CTab title="پیش‌بینی موجودی انبار">
          <CDataTableFixed sorter
                           column-filter
                           :items="inventoryData" :fields="inventoryFields" striped hover>
            <template #stock_status="{item}">
              <td>
                <CBadge :color="getStockBadge(item.stock_status)">{{ item.stock_status }}</CBadge>
              </td>
            </template>
            <template #title="{item}">
              <td>
               <p>{{item.title.title}}</p>
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- نرخ تبدیل -->
        <CTab title="نرخ تبدیل بازدید به خرید">
          <CDataTableFixed sorter
                           column-filter
                           :items="conversionData" :fields="conversionFields" striped hover>
            <template #conversion_rate="{item}">
              <td>
                <CBadge :color="getConversionBadge(item.conversion_rate)">{{ item.conversion_rate }}%</CBadge>
              </td>
            </template>
            <template #title="{item}">
              <td>
                <p>{{item.title.title}}</p>
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- روش‌های پرداخت -->
        <CTab title="کارایی روش‌های پرداخت">
          <CDataTableFixed sorter
                           column-filter
                           :items="paymentData" :fields="paymentFields" striped hover>
            <template #success_rate="{item}">
              <td>
                <CBadge :color="getSuccessBadge(item.success_rate)">{{ item.success_rate }}%</CBadge>
              </td>
            </template>



            <template #total_transactions="{item}">
              <td>
                {{ get_currency(item.total_transactions) }}
              </td>
            </template>
            <template #total_amount="{item}">
              <td>
                {{ get_currency(item.total_amount) }}
              </td>
            </template>
            <template #avg_transaction="{item}">
              <td>
                {{ get_currency(item.avg_transaction) }}
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- تحلیل فصلی -->
        <CTab title="تحلیل فصلی">
          <CDataTableFixed sorter
                           column-filter
                           :items="seasonalData" :fields="seasonalFields" striped hover>

            <template #total_orders="{item}">
              <td>
                {{ get_currency(item.total_orders) }}
              </td>
            </template>
            <template #total_revenue="{item}">
              <td>
                {{ get_currency(item.total_revenue) }}
              </td>
            </template>
            <template #unique_customers="{item}">
              <td>
                {{ get_currency(item.unique_customers) }}
              </td>
            </template>
            <template #avg_customer_value="{item}">
              <td>
                {{ get_currency(item.avg_customer_value) }}
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- محصولات پر بازدید کم فروش -->
        <CTab title="محصولات پر بازدید کم فروش">
          <CDataTableFixed sorter
                           column-filter
                           :items="highViewsData" :fields="highViewsFields" striped hover>
            <template #potential_status="{item}">
              <td>
                <CBadge :color="getPotentialBadge(item.potential_status)">{{ item.potential_status }}</CBadge>
              </td>
            </template>
            <template #title="{item}">
              <td>
                <p>{{item.title.title}}</p>
              </td>
            </template>


            <template #total_views="{item}">
              <td>
                {{ get_currency(item.total_views) }}
              </td>
            </template>
            <template #total_purchases="{item}">
              <td>
                {{ get_currency(item.total_purchases) }}
              </td>
            </template>
          </CDataTableFixed>
        </CTab>

        <!-- تحلیل جغرافیایی -->
        <CTab title="تحلیل جغرافیایی">
          <CDataTableFixed sorter
                           column-filter
                           :items="geoData" :fields="geoFields" striped hover>


            <template #total_customers="{item}">
              <td>
                {{ get_currency(item.total_customers) }}
              </td>
            </template>
            <template #total_orders="{item}">
              <td>
                {{ get_currency(item.total_orders) }}
              </td>
            </template>
            <template #total_revenue="{item}">
              <td>
                {{ get_currency(item.total_revenue) }}
              </td>
            </template>
            <template #avg_customer_value="{item}">
              <td>
                {{ get_currency(item.avg_customer_value) }}
              </td>
            </template>
          </CDataTableFixed>
        </CTab>
        <CTab title="تحلیل خرید مشتریان">
         <AiAssistantCustomersComponent/>
        </CTab>
      </CTabs>
    </CCard>
  </div>
</template>

<script>
import axios from "axios";
import AiAssistantCustomersComponent from "@/views/reports/AiAssistantCustomersComponent.vue";
import SaleAssistant from "@/views/reports/SaleAssistant.vue";
export default {
  name: 'AdvancedAnalyticsDashboard',
  components:{
    AiAssistantCustomersComponent,
    SaleAssistant
  },
  data() {
    return {
      priceSensitivityData: [],
      customerSegments: [],
      segmentSummary: {},
      starsData: [],
      dogsData: [],
      deadData: [],

      // فیلدهای جداول
      priceSensitivityFields: [
        {key: 'product_name', label: 'نام محصول', _style: 'width:3%'},
        {key: 'avg_price', label: 'میانگین قیمت', _style: 'width:10%'},
        {key: 'avg_discount', label: 'میانگین تخفیف', _style: 'width:10%'},
        {key: 'total_sales', label: 'تعداد فروش', _style: 'width:10%'},
        {key: 'total_revenue', label: 'درآمد کل', _style: 'width:10%'},
        {key: 'sensitivity_index', label: 'شاخص حساسیت', _style: 'width:10%'},
        {key: 'actions', label: 'اقدامات', _style: 'width:10%'}
      ],

      segmentFields: [
        {key: 'name', label: 'نام مشتری'},
        {key: 'phone', label: 'تلفن'},
        {key: 'order_count', label: 'تعداد سفارشات'},
        {key: 'total_spent', label: 'کل خرید'},
        {key: 'days_since_last_order', label: 'روز از آخرین خرید'},
        {key: 'segment', label: 'سگمنت'},
        {key: 'actions', label: 'اقدامات'}
      ],

      productFields: [
        {key: 'title', label: 'نام محصول'},
        {key: 'total_sold', label: 'تعداد فروش'},
        {key: 'total_revenue', label: 'درآمد کل'},
        {key: 'avg_price', label: 'میانگین قیمت'},
        {key: 'current_stock', label: 'موجودی فعلی'},
        {key: 'category', label: 'دسته‌بندی'},
        {key: 'actions', label: 'اقدامات'}
      ],


      rfmData: [],
      discountData: [],
      ltvData: [],
      basketData: [],
      inventoryData: [],
      conversionData: [],
      paymentData: [],
      seasonalData: [],
      highViewsData: [],
      geoData: [],

      // فیلدهای جداول
      rfmFields: [
        {key: 'name', label: 'نام مشتری'},
        {key: 'phone', label: 'تلفن'},
        {key: 'frequency', label: 'تعداد خرید'},
        {key: 'recency', label: 'روز از آخرین خرید'},
        {key: 'monetary', label: 'مبلغ کل'},
        {key: 'segment', label: 'سگمنت'}
      ],

      discountFields: [
        {key: 'title', label: 'محصول'},
        {key: 'avg_discount', label: 'میانگین تخفیف'},
        {key: 'total_sales', label: 'تعداد فروش'},
        {key: 'total_revenue', label: 'درآمد کل'},
        {key: 'effectiveness_ratio', label: 'کارایی تخفیف'}
      ],

      ltvFields: [
        {key: 'name', label: 'نام مشتری'},
        {key: 'phone', label: 'تلفن'},
        {key: 'total_orders', label: 'تعداد سفارشات'},
        {key: 'lifetime_value', label: 'ارزش طول عمر'},
        {key: 'customer_span', label: 'طول عمر (روز)'},
        {key: 'ltv_per_month', label: 'LTV ماهانه'}
      ],

      basketFields: [
        {key: 'product_a_name', label: 'محصول اول'},
        {key: 'product_b_name', label: 'محصول دوم'},
        {key: 'times_bought_together', label: 'تعداد خرید مشترک'},
        {key: 'support_percentage', label: 'درصد پشتیبانی'}
      ],

      inventoryFields: [
        {key: 'title', label: 'محصول'},
        {key: 'current_stock', label: 'موجودی فعلی'},
        {key: 'sold_last_30_days', label: 'فروش ۳۰ روز'},
        {key: 'avg_weekly_sales', label: 'میانگین فروش هفتگی'},
        {key: 'stock_status', label: 'وضعیت موجودی'}
      ],

      conversionFields: [
        {key: 'title', label: 'محصول'},
        {key: 'total_views', label: 'تعداد بازدید'},
        {key: 'total_purchases', label: 'تعداد خرید'},
        {key: 'conversion_rate', label: 'نرخ تبدیل'}
      ],

      paymentFields: [
        {key: 'gateway_name', label: 'درگاه پرداخت'},
        {key: 'total_transactions', label: 'تعداد تراکنش‌ها'},
        {key: 'total_amount', label: 'مبلغ کل'},
        {key: 'avg_transaction', label: 'میانگین تراکنش'},
        {key: 'success_rate', label: 'نرخ موفقیت'}
      ],

      seasonalFields: [
        {key: 'year', label: 'سال'},
        {key: 'month', label: 'ماه'},
        {key: 'total_orders', label: 'تعداد سفارشات'},
        {key: 'total_revenue', label: 'درآمد کل'},
        {key: 'unique_customers', label: 'مشتریان منحصر بفرد'},
        {key: 'avg_customer_value', label: 'میانگین ارزش مشتری'}
      ],

      highViewsFields: [
        {key: 'title', label: 'محصول'},
        {key: 'total_views', label: 'تعداد بازدید'},
        {key: 'total_purchases', label: 'تعداد خرید'},
        {key: 'conversion_rate', label: 'نرخ تبدیل'},
        {key: 'potential_status', label: 'وضعیت پتانسیل'}
      ],

      geoFields: [
        {key: 'province', label: 'استان'},
        {key: 'city', label: 'شهر'},
        {key: 'total_customers', label: 'تعداد مشتریان'},
        {key: 'total_orders', label: 'تعداد سفارشات'},
        {key: 'total_revenue', label: 'درآمد کل'},
        {key: 'avg_customer_value', label: 'میانگین ارزش مشتری'}
      ]
    }
  },

  computed: {
    starsCount() {
      return this.starsData.length;
    },
    dogsCount() {
      return this.dogsData.length;
    },
    deadCount() {
      return this.deadData.length;
    }
  },

  mounted() {
    this.loadAdvancedAnalytics();
    this.loadAdvancedAnalytics2();

  },

  methods: {
    async loadAdvancedAnalytics() {
      try {
        const [sensitivityRes, segmentsRes, productsRes] = await Promise.all([
          axios.get('/api/admin/analytics/price-sensitivity'),
          axios.get('/api/admin/analytics/customer-segments'),
          axios.get('/api/admin/analytics/stars-dogs')
        ]);

        this.priceSensitivityData = sensitivityRes.data.data;
        this.customerSegments = segmentsRes.data.segments;
        this.segmentSummary = segmentsRes.data.summary;
        this.starsData = productsRes.data.stars;
        this.dogsData = productsRes.data.dogs;
        this.deadData = productsRes.data.dead;

      } catch (error) {
        console.error('Error loading advanced analytics:', error);
        this.$notify.error('خطا در بارگذاری داده‌های تحلیلی پیشرفته');
      }
    },


    async loadAdvancedAnalytics2() {
      try {
        const [res1, res2, res3, res4, res5, res6, res7, res8, res9, res10] = await Promise.all([
          axios.get('/api/admin/analytics/rfm-analysis'),
          axios.get('/api/admin/analytics/discount-effectiveness'),
          axios.get('/api/admin/analytics/market-basket'),
          axios.get('/api/admin/analytics/inventory-forecast'),
          axios.get('/api/admin/analytics/conversion-rate'),
          axios.get('/api/admin/analytics/payment-methods'),
          axios.get('/api/admin/analytics/seasonal-analysis'),
          axios.get('/api/admin/analytics/high-views-low-sales'),
          axios.get('/api/admin/analytics/geographic-analysis'),
          axios.get('/api/admin/analytics/customer-ltv'),
        ]);

        this.rfmData = res1.data.data;
        this.discountData = res2.data.data;
        this.basketData = res3.data.data;
        this.inventoryData = res4.data.data;
        this.conversionData = res5.data.data;
        this.paymentData = res6.data.data;
        this.seasonalData = res7.data.data;
        this.highViewsData = res8.data.data;
        this.geoData = res9.data.data;
        this.ltvData = res10.data.data;

        // this.starsData = productsRes.data.stars;
        // this.dogsData = productsRes.data.dogs;
        // this.deadData = productsRes.data.dead;

      } catch (error) {
        console.error('Error loading advanced analytics:', error);
        this.$notify.error('خطا در بارگذاری داده‌های تحلیلی پیشرفته');
      }
    },

    getSensitivityBadge(value) {
      if (value > 50) return 'success';
      if (value > 20) return 'warning';
      return 'danger';
    },

    getSegmentTitle(segment) {
      const titles = {
        'VIP': 'مشتریان VIP',
        'LOYAL': 'مشتریان وفادار',
        'AT_RISK': 'در معرض خطر',
        'NEW': 'مشتریان جدید',
        'REGULAR': 'مشتریان عادی'
      };
      return titles[segment] || segment;
    },

    getSegmentBadge(segment) {
      const variants = {
        'VIP': 'success',
        'LOYAL': 'info',
        'AT_RISK': 'warning',
        'NEW': 'primary',
        'REGULAR': 'secondary'
      };
      return variants[segment] || 'secondary';
    },

    applyDiscountStrategy(product) {
      this.$bvModal.msgBoxConfirm(
          `آیا می‌خواهید برای محصول "${product.product_name}" استراتژی تخفیف اعمال کنید؟`,
          {
            title: 'اعمال استراتژی تخفیف',
            okVariant: 'success',
            okTitle: 'تأیید',
            cancelTitle: 'لغو'
          }
      ).then(confirmed => {
        if (confirmed) {
          // پیاده‌سازی منطق اعمال تخفیف
          this.$notify.success(`استراتژی تخفیف برای ${product.product_name} اعمال شد`);
        }
      });
    },

    applyClearanceStrategy(product) {
      this.$bvModal.msgBoxConfirm(
          `آیا می‌خواهید محصول "${product.title}" را حراجی فوری کنید؟`,
          {
            title: 'حراجی فوری',
            okVariant: 'danger',
            okTitle: 'حراجی',
            cancelTitle: 'لغو'
          }
      ).then(confirmed => {
        if (confirmed) {
          // پیاده‌سازی منطق حراجی فوری
          this.$notify.success(`محصول ${product.title} به حراجی اضافه شد`);
        }
      });
    },

    viewCustomerDetails(customer) {
      this.$router.push({
        name: 'CustomerDetails',
        params: {id: customer.id}
      });
    },


    getRfmBadge(segment) {
      const variants = {
        'VIP': 'success',
        'LOYAL': 'info',
        'AT_RISK': 'warning',
        'REGULAR': 'secondary'
      };
      return variants[segment] || 'secondary';
    },

    getStockBadge(status) {
      const variants = {
        'OK': 'success',
        'LOW': 'warning',
        'CRITICAL': 'danger',
        'OUT_OF_STOCK': 'dark'
      };
      return variants[status] || 'secondary';
    },

    getConversionBadge(rate) {
      if (rate > 10) return 'success';
      if (rate > 5) return 'info';
      if (rate > 2) return 'warning';
      return 'danger';
    },

    getSuccessBadge(rate) {
      if (rate > 90) return 'success';
      if (rate > 75) return 'info';
      if (rate > 50) return 'warning';
      return 'danger';
    },

    getPotentialBadge(status) {
      const variants = {
        'HIGH_POTENTIAL': 'success',
        'MEDIUM_POTENTIAL': 'info',
        'NORMAL': 'secondary'
      };
      return variants[status] || 'secondary';
    }
  }
}
</script>

<style scoped>
.advanced-analytics {
  padding: 20px;
}

.card {
  margin-bottom: 20px;
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.table {
  font-size: 0.9rem;
}

.badge {
  font-size: 0.8rem;
  padding: 0.4em 0.6em;
}
</style>